export default __webpack_public_path__ + "static/media/002-african mask.15882e9e.svg";